module.exports = __webpack_public_path__ + "img/step3.111d6c7e.png";